import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import {OutwardTableComponent} from './outward-table/outward-table.component';

@Component({
  selector: 'app-outward',
  templateUrl: './outward.component.html',
  styleUrls: ['./outward.component.css']
})
export class OutwardComponent implements OnInit {

  constructor(private appComponent: AppComponent) { }

  ngOnInit(): void {
    
  }

}
